var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Print_duotone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4117",
    d: "M5.66675 12.5C5.66675 10.6144 5.66675 9.67157 6.25253 9.08579C6.83832 8.5 7.78113 8.5 9.66675 8.5H24.3334C26.219 8.5 27.1618 8.5 27.7476 9.08579C28.3334 9.67157 28.3334 10.6144 28.3334 12.5V17.8333C28.3334 18.7761 28.3334 19.2475 28.0405 19.5404C27.7476 19.8333 27.2762 19.8333 26.3334 19.8333H24.3834C24.242 19.8333 24.1713 19.8333 24.1273 19.7894C24.0834 19.7455 24.0834 19.6748 24.0834 19.5333V17.5833C24.0834 16.6405 24.0834 16.1691 23.7905 15.8762C23.4976 15.5833 23.0262 15.5833 22.0834 15.5833H11.9167C10.9739 15.5833 10.5025 15.5833 10.2096 15.8762C9.91675 16.1691 9.91675 16.6405 9.91675 17.5833V19.5333C9.91675 19.6748 9.91675 19.7455 9.87281 19.7894C9.82888 19.8333 9.75817 19.8333 9.61675 19.8333H6.66675C6.19534 19.8333 5.95964 19.8333 5.81319 19.6869C5.66675 19.5404 5.66675 19.3047 5.66675 18.8333V12.5Z",
    fill: "url(#paint0_linear_862_6560)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 57",
    d: "M9.91675 29.0115L9.91675 17.5833C9.91675 16.6405 9.91675 16.1691 10.2096 15.8762C10.5025 15.5833 10.9739 15.5833 11.9167 15.5833L22.0834 15.5833L22.0834 15.5833C23.0262 15.5833 23.4976 15.5833 23.7905 15.8762C24.0834 16.1691 24.0834 16.6405 24.0834 17.5833L24.0834 29.0115C24.0834 29.3461 24.0834 29.5134 23.9736 29.5878C23.8637 29.6621 23.7084 29.6 23.3977 29.4757L20.7274 28.4076C20.6357 28.3709 20.5899 28.3526 20.5417 28.3526C20.4936 28.3526 20.4478 28.3709 20.3561 28.4076L17.1858 29.6757C17.0941 29.7124 17.0482 29.7307 17.0001 29.7307C16.9519 29.7307 16.9061 29.7124 16.8144 29.6757L13.6441 28.4076C13.5524 28.3709 13.5066 28.3526 13.4584 28.3526C13.4103 28.3526 13.3644 28.3709 13.2727 28.4076L10.6024 29.4757C10.2918 29.6 10.1364 29.6621 10.0266 29.5878C9.91675 29.5134 9.91675 29.3461 9.91675 29.0115Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 56",
    d: "M13.4583 20.5417L19.1249 20.5417",
    stroke: "url(#paint1_linear_862_6560)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 58",
    d: "M13.4583 24.7917L20.5416 24.7917",
    stroke: "url(#paint2_linear_862_6560)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4134",
    d: "M9.91675 6.25C9.91675 5.30719 9.91675 4.83579 10.2096 4.54289C10.5025 4.25 10.9739 4.25 11.9167 4.25H22.0834C23.0262 4.25 23.4976 4.25 23.7905 4.54289C24.0834 4.83579 24.0834 5.30719 24.0834 6.25V6.78333C24.0834 6.92475 24.0834 6.99547 24.0395 7.0394C23.9955 7.08333 23.9248 7.08333 23.7834 7.08333H10.2167C10.0753 7.08333 10.0046 7.08333 9.96068 7.0394C9.91675 6.99547 9.91675 6.92475 9.91675 6.78333V6.25Z",
    fill: "url(#paint3_linear_862_6560)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_6560",
    x1: 17.0001,
    y1: 8.5,
    x2: 17.0001,
    y2: 19.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654D1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_862_6560",
    x1: 16.2916,
    y1: 20.5417,
    x2: 16.2916,
    y2: 21.5417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654D1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_862_6560",
    x1: 16.9999,
    y1: 24.7917,
    x2: 16.9999,
    y2: 25.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654D1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_862_6560",
    x1: 17.0001,
    y1: 4.25,
    x2: 17.0001,
    y2: 7.08333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654D1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.7762ec8490bb4c076bf3f19b0ab81a98.svg";
export { ForwardRef as ReactComponent };